import axios from "axios";

// Re-export existing MRP helpers already in jobApi so consumers can
// import everything MRP-related from one place.
export {
  getJobBOM as calculateJobBOM,
  runMRP,
  getJobRequirements,
} from "./jobApi";

// ── Additional MRP endpoints (from API Guide §9) ────────────

/**
 * Run MRP for multiple jobs in one batch.
 * POST /v1/mrp/run-batch
 *
 * @param {string[]} jobIds
 * @returns {{ total, succeeded, failed, results[] }}
 */
export const runBatchMRP = async (jobIds) => {
  const response = await axios.post("mrp/run-batch", { job_ids: jobIds });
  return response.data;
};

/**
 * Get shortage report (aggregated across jobs).
 * GET /v1/mrp/shortages
 *
 * @param {object} filters - { stage?, material_id? }
 * @returns {{ total_shortages, shortages[], aggregated[] }}
 */
export const getShortageReport = async (filters = {}) => {
  const response = await axios.get("mrp/shortages", { params: filters });
  return response.data;
};

/**
 * Generate a Purchase Request from an MRP shortage.
 * POST /v1/mrp/shortages/generate-pr
 *
 * @param {{ material_id, quantity, unit, job_ids[], notes? }} data
 * @returns {{ message, purchase_request }}
 */
export const generatePRFromShortage = async (data) => {
  const response = await axios.post("mrp/shortages/generate-pr", data);
  return response.data;
};
